import { lazy } from 'react';

const Select = lazy(() => import('./Select'));

export { Select };
